import { theme as antdTheme, ConfigProvider } from "antd";
import type React from "react";
import { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useTheme } from "./context/ThemeContext";
import MainLayout from "./layouts/MainLayout";

const App: React.FC = () => {
  // Tablet (768–1199px) starts with a collapsed icon sider; desktop expanded.
  const [collapsed, setCollapsed] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 768 && window.innerWidth < 1200,
  );
  const { isDark } = useTheme();

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
        token: {
          colorPrimary: "#f56565",
          borderRadius: 8,
          controlHeight: 40,
        },
      }}
    >
      <Router>
        <MainLayout collapsed={collapsed} onCollapse={setCollapsed} />
      </Router>
    </ConfigProvider>
  );
};

export default App;
